import Button from '@components/Button'
import Modal from '@components/Modal'
import classnames from 'classnames'
import { useDispatch } from 'react-redux'
import { deleteWaitListItem } from '../actions'
import styles from './styles.module.scss'

const WaitListModal = ({ closeModal, waitListId }) => {
    const dispatch = useDispatch()
    const deleteItemHandler = () => {
        dispatch(deleteWaitListItem(waitListId))
        closeModal()
    }
    return (
        <Modal size="small" onClose={closeModal} className={styles.cancelModal}>
            <h5 className={styles.title}>
                <T>dashboard.label.waitList.removing.message.title</T>
            </h5>
            <div>
                <T>dashboard.label.waitList.removing.message</T>
            </div>
            <div className={classnames('d-flex', styles.buttons)}>
                <Button block btnStyle="outline" onClick={closeModal}>
                    <T>dashboard.label.waitList.removing.cancel</T>
                </Button>
                <Button block btnStyle="primary" onClick={deleteItemHandler}>
                    <T>dashboard.label.waitList.removing.accept</T>
                </Button>
            </div>
        </Modal>
    )
}

export default WaitListModal
